<template>
  <div class="nps-ques">
    <score-bar :beginDesc = 'ques.starBeginDesc' :endDesc = 'ques.starEndDesc' :activeScore = 'level'
               :themeColor = 'themeColor' @changeScore = 'changeScore'></score-bar>
    <div class = 'lable-wrap' v-if = 'ques.label && activeQuesIndex !== null &&
    (ques.labelSetting[activeQuesIndex].question || ques.labelSetting[activeQuesIndex].evaluation.length > 0)'>
      <p class = 'question' v-if = 'ques.labelSetting[activeQuesIndex].question' >{{ques.labelSetting[activeQuesIndex].question}}</p>
      <div class = 'label-container' v-if = 'ques.labelSetting[activeQuesIndex].evaluation.length > 0'>
        <span class = 'label' v-for = '(label , index) in ques.labelSetting[activeQuesIndex].evaluation' :key = 'index'
              :class = "{'active': evaluateLabels.indexOf(label) >= 0}"
        @click = 'selectLabel(label)'>
          {{label}}
        </span>
      </div>
    </div>
    <div class="introduction-text_content" v-if = 'ques.textBox && activeQuesIndex !== null'>
      <el-input
        class="introduction-text"
        type="textarea"
        maxlength="300"
        :placeholder="ques.leadingWords"
        v-model = 'answer.userEvaluation'
        @change="handleInput">
      </el-input>
      <div class="el-input_count" v-show="answer.userEvaluation && answer.userEvaluation.length > 0">{{answer.userEvaluation.length}}/300</div>
    </div>

  </div>
</template>
<script>
import scoreBar from './scoreBar'
export default {
  name: 'nps',
  data() {
    return {
      level: -1,
      activeQuesIndex: null, //预览时选中的问题和评价标签组
      evaluateLabels: [],
      answer: {
        level: -1, // 打分数
        evaluateLabels: [], // 标签数组
        userEvaluation: '' // 用户填答内容
      }
    }
  },
  props: ['ques', 'themeColor'],
  components: {
    scoreBar
  },
  created() {
  },
  watch: {
    ques: {
      immediate: true,
      handler() {
        this.$set(this.ques, 'answer', this.answer)
      }
    }
  },
  methods: {
    changeScore(score) {
      this.answer.level = score
      this.getActiveQues()
      this.ques.isFinish = true
    },
    getActiveQues() {
      const beforeQuesIndex = this.activeQuesIndex
      if (this.answer.level >= 0 && this.answer.level <= 6) {
        this.activeQuesIndex = 0
      } else if (this.answer.level >= 7 && this.answer.level <= 8) {
        this.activeQuesIndex = 1
      } else if (this.answer.level >= 9 && this.answer.level <= 10) {
        this.activeQuesIndex = 2
      }
      if (this.activeQuesIndex !== beforeQuesIndex) {
        this.evaluateLabels = []
        this.answer.evaluateLabels = []
      }
    },
    selectLabel(label) {
      const index = this.evaluateLabels.indexOf(label)
      if (index < 0) {
        this.evaluateLabels.push(label)
      } else {
        this.evaluateLabels.splice(index, 1)
      }
      this.answer.evaluateLabels = this.evaluateLabels
    },
    handleInput(val) {
      this.ques.answer.userEvaluation = val
    }
  }
}
</script>
<style lang="scss" scoped>
.lable-wrap {
  margin-top: 14px;
  .question {
    padding-top: 10px;
    color: $font-color-deep;
  }
  .label-container {
    .label {
      display: inline-block;
      padding: 5px 15px;
      color: $font-color-default;
      line-height: 18px;
      border: 1px solid $border-color-default;
      border-radius: 2px;
      margin-right: 10px;
      margin-top: 10px;
      background-color: #ffffff;
      cursor: pointer;
      &.active {
        border-color: var(--themeColor);
        color: var(--themeColor);
      }
    }
  }
}
.introduction-text {
  margin-top: 24px;
  /deep/ textarea{
    width: 100%;
    height: 100px;
    padding: 10px;
    line-height: 20px;
    font-size: 14px;
    font-weight: normal;
    -webkit-appearance: none;
  }
}
.introduction-text_content{
  position: relative;
  .el-input_count{
    color: #909399;
    background: #fff;
    position: absolute;
    font-size: 12px;
    bottom: 5px;
    right: 10px;
    transform: scale(0.9);
  }
}
@media screen and (max-width: 468px) {
}
</style>




// WEBPACK FOOTER //
// src/components/nps.vue